import actions from './actions'

const initialState = {
  data: [],
  isFetching: false,
  error: '',
}

export default function reduxSagaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_GROUPS: {
      return {
        ...state,
        isFetching: true,
        error: '',
      }
    }

    case actions.FETCH_GROUPS_SUCCESS: {
      return {
        ...state,
        data: action.data,
        isFetching: false,
        error: '',
      }
    }

    case actions.FETCH_GROUPS_ERROR: {
      return {
        ...state,
        isFetching: false,
      }
    }

    case actions.GROUP_SET: {
      return {
        ...state,
        data: action.data,
        isSaving: true,
        error: '',
      }
    }

    case actions.GROUP_ADD: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.GROUP_DEL: {
      return {
        ...state,
        isSaving: true,
        error: '',
      }
    }

    case actions.GROUP_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        error: '',
      }
    }

    case actions.GROUP_ERROR: {
      return {
        ...state,
        isSaving: false,
      }
    }

    default: {
      return state
    }
  }
}
